import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function ComparisonSection() {
  const problems = ['Dudas sobre qué decisión tomar', 'Preocupación por un familiar', 'Miedo a equivocarte', 'Falta de orientación clara', 'Sensación de estar enfrentando el problema solo'];
  const solutions = ['Primer paso más claro', 'Comunicación directa y confidencial', 'Mayor tranquilidad para la familia', 'Acompañamiento humano', 'Información para avanzar con más seguridad'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-22">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-24">
          {/* Left Side - Problems */}
          <div className="bg-gray-50 p-8 md:p-10 rounded-3xl border border-gray-200" data-id="element-25">
            <h3 className="text-2xl font-bold text-gray-800 mb-8" data-id="element-26">
              Cuando no sabes por dónde empezar
            </h3>
            <ul className="space-y-5" data-id="element-27">
              {problems.map((item, index) => <li key={index} className="flex items-start" data-id="element-28">
                  <XCircle className="w-6 h-6 text-gray-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-29" />
                  <span className="text-gray-600" data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Side - Solutions */}
          <div className="bg-celeste-light/30 p-8 md:p-10 rounded-3xl border border-celeste-soft" data-id="element-31">
            <h3 className="text-2xl font-bold text-azul mb-8" data-id="element-32">
              Cuando recibes orientación profesional
            </h3>
            <ul className="space-y-5" data-id="element-33">
              {solutions.map((item, index) => <li key={index} className="flex items-start" data-id="element-34">
                  <CheckCircle2 className="w-6 h-6 text-celeste mr-3 flex-shrink-0 mt-0.5" data-id="element-35" />
                  <span className="text-gray-800 font-medium" data-id="element-36">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}